module.exports = __webpack_public_path__ + "static/media/Monday_Step5_Image0.7838ad97.jpg";